"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAPRequest = void 0;
const mapAPRequest = (params) => {
    return {
        countryCode: "US",
        currencyCode: "USD",
        lineItems: [],
        merchantCapabilities: ["supports3DS"],
        requiredBillingContactFields: ["postalAddress"],
        requiredShippingContactFields: [],
        shippingMethods: [],
        shippingType: "storePickup",
        supportedNetworks: ["visa", "masterCard", "amex", "discover", "jcb"],
        total: {
            label: `${params.vendorName}:`,
            amount: `${params.amount}`,
            type: "final"
        }
    };
};
exports.mapAPRequest = mapAPRequest;
